import { getContentstackImagesForWidths } from '@noths/polaris-client-utils';
import dynamic from 'next/dynamic';

import { YouTubeVideoBlockBlockProps } from 'src/components/blocks/YouTubeVideoBlockBlock';
import { lazyLoadImages } from 'src/utils/images';
import { ContentBlockRenderer } from '../../../types/Block';
import { Transformer } from '../../../types/Transformer';
import { VideoBlockContentSection } from './types';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<YouTubeVideoBlockBlockProps> =
  dynamic<YouTubeVideoBlockBlockProps>(() =>
    import('src/components/blocks/YouTubeVideoBlockBlock').then(
      (mod) => mod.YouTubeVideoBlockBlock,
    ),
  );

export const transformer: Transformer<VideoBlockContentSection, YouTubeVideoBlockBlockProps> = (
  { _metadata, youtube_id, caption = '', title = '', thumbnail, tracking_title },
  { positionMetadata },
) => ({
  uid: _metadata.uid,
  props: {
    youtubeId: youtube_id,
    ...(thumbnail
      ? {
          thumbnailImages: getContentstackImagesForWidths(
            thumbnail.url,
            [360, 500, 700, 900, 1132],
            {
              aspectRatio: '16:9',
            },
          ),
          thumbnailWidth: 360,
          thumbnailHeight: 216,
        }
      : { thumbnailImages: [] }),
    title,
    caption,
    trackingTitle: tracking_title,
    lazyImages: lazyLoadImages(positionMetadata.position),
  },
});
